/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 8/25/20
 *
 */
import BaseFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/BaseFormElement";
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";

export default class FormElementDate extends BaseFormElement {

	constructor(title, isRequired) {
		super(FormElementType.DATE, title, isRequired);
	}

}
